/**
 * Single shared TanStack-Query key factory for the caller's workspace
 * list (`GET /api/account/me/workspaces`) — IA-2.2 chrome.
 *
 * Mirrors `meAuditKey` (W2-A) + `meInsightsKey` (B.3) + `teamConfigKey`
 * (Wave 1.5 fix G-CC2): every query key tuple for an authenticated read
 * includes `accountId` so cross-account cache reuse is impossible. If
 * a member signs out and back in as a different account, the previous
 * owner's workspace memberships can't leak from cache because the key
 * changes.
 *
 * The key is `as const` so TanStack's typed query-key inference flows
 * through; pass the same `(accountId)` tuple to every useQuery /
 * setQueryData / invalidateQueries call.
 */
export const workspacesKey = (accountId: string | null) => ["me-workspaces", accountId] as const;

export type WorkspacesKey = ReturnType<typeof workspacesKey>;
